<template>
  <div class="flex-col">
    <div class="">
      <dd-back-button id="page-header-back-button" :back-handler="backHandler || null" :bread-crumbs="breadCrumbs"/>
    </div>
    <h1 class="mb-0">
      <slot></slot>
    </h1>
  </div>

</template>

<script>
export default {
  name: "PageHeader",
  props: {
    breadCrumbs: {
      type: Array,
      required: false,
    },
    backHandler: {
      type: Function,
      required: false,
    },
  },
}
</script>

<style>
#page-header-back-button{
  button.go-back{
    margin-top: 0 !important;
  }
}
</style>

